import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { Image } from "@components/core";

function GiftCardNavbar() {
  const tGiftCards = useTranslations("gift_cards");
  const tCommon = useTranslations("common");

  const router = useRouter();

  return (
    <div className="border-bottom d-flex justify-content-center align-items-center gift-card-navbar position-relative">
      <h1 className="mb-0 h3">{tGiftCards("gift_cards_navbar_title")}</h1>
      <button
        type="button"
        className="btn-transparent position-absolute"
        style={{ left: 10 }}
        onClick={() => router.back()}
      >
        <Image
          src="arrowFat"
          alt={tCommon("back")}
          className="back-button my-auto"
        />
      </button>
    </div>
  );
}

export default GiftCardNavbar;
